import ReduxThunk from 'redux-thunk';
import { createStore, applyMiddleware} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import adminReducer  from './reducers/index';

const createStoreMiddleStore= applyMiddleware(ReduxThunk)(createStore);
export const adminStore= createStoreMiddleStore(adminReducer, composeWithDevTools());
